/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DueDateDto } from './DueDateDto';
import {
    DueDateDtoFromJSON,
    DueDateDtoFromJSONTyped,
    DueDateDtoToJSON,
    DueDateDtoToJSONTyped,
} from './DueDateDto';
import type { MandatePayer } from './MandatePayer';
import {
    MandatePayerFromJSON,
    MandatePayerFromJSONTyped,
    MandatePayerToJSON,
    MandatePayerToJSONTyped,
} from './MandatePayer';

/**
 * 
 * @export
 * @interface UpdateQuoteMandateDto
 */
export interface UpdateQuoteMandateDto {
    /**
     * Date calendaire "yyyy-MM-dd" (début du mandat) — sans heure ni offset
     * @type {string}
     * @memberof UpdateQuoteMandateDto
     */
    startDate: string;
    /**
     * 
     * @type {DueDateDto}
     * @memberof UpdateQuoteMandateDto
     */
    dueDate?: DueDateDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateQuoteMandateDto
     */
    frequencyId: string;
    /**
     * Compte bancaire à débiter — doit appartenir au payeur choisi (vérifié par le back)
     * @type {string}
     * @memberof UpdateQuoteMandateDto
     */
    bankAccountId?: string;
    /**
     * 
     * @type {MandatePayer}
     * @memberof UpdateQuoteMandateDto
     */
    payer?: MandatePayer;
}



/**
 * Check if a given object implements the UpdateQuoteMandateDto interface.
 */
export function instanceOfUpdateQuoteMandateDto(value: object): value is UpdateQuoteMandateDto {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('frequencyId' in value) || value['frequencyId'] === undefined) return false;
    return true;
}

export function UpdateQuoteMandateDtoFromJSON(json: any): UpdateQuoteMandateDto {
    return UpdateQuoteMandateDtoFromJSONTyped(json, false);
}

export function UpdateQuoteMandateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateQuoteMandateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'],
        'dueDate': json['dueDate'] == null ? undefined : DueDateDtoFromJSON(json['dueDate']),
        'frequencyId': json['frequencyId'],
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
        'payer': json['payer'] == null ? undefined : MandatePayerFromJSON(json['payer']),
    };
}

export function UpdateQuoteMandateDtoToJSON(json: any): UpdateQuoteMandateDto {
    return UpdateQuoteMandateDtoToJSONTyped(json, false);
}

export function UpdateQuoteMandateDtoToJSONTyped(value?: UpdateQuoteMandateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': value['startDate'],
        'dueDate': DueDateDtoToJSON(value['dueDate']),
        'frequencyId': value['frequencyId'],
        'bankAccountId': value['bankAccountId'],
        'payer': MandatePayerToJSON(value['payer']),
    };
}

